import { Component, input } from '@angular/core';

import { NgClass } from '@angular/common';
import { TooltipDirective } from '@app/directives/tooltip.directive';
import { MoneyPipe } from '../../../pipes/framework/money-short.pipe';
import { ICashflowStatRow } from '../cashflow-table/cashflow.types';
import { CASHFLOW_CONSTANTS } from '@app/pages/webapp/cash-flow/cash-flow.constants';

@Component({
  selector: 'app-cash-flow-stats',
  templateUrl: './cash-flow-stats.component.html',
  styleUrls: ['./cash-flow-stats.component.scss'],
  imports: [NgClass, TooltipDirective, MoneyPipe],
})
export class CashFlowStatsComponent {
  cashflowStats = input<ICashflowStatRow[]>(CASHFLOW_CONSTANTS.COMMITMENT_STATS);
}
